import { render, staticRenderFns } from "./ma.vue?vue&type=template&id=5c8574f0&"
import script from "./ma.vue?vue&type=script&lang=js&"
export * from "./ma.vue?vue&type=script&lang=js&"
import style0 from "./ma.vue?vue&type=style&index=0&id=5c8574f0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports